import type { Selector } from 'reselect';
import { createSelector } from 'reselect';

import type { Assets } from '@/types';
import selectors from '@/ui/flux/selectors';

const enabledAssetsSelector = createSelector(
  selectors.assets.all as Selector<unknown, Assets>,
  selectors.enabledAssets.getIsEnabled as Selector<
    unknown,
    (name: string) => boolean
  >,
  (assets, getIsAssetEnabled) =>
    Object.fromEntries(
      Object.entries(assets).filter(([, asset]) =>
        getIsAssetEnabled(asset.name),
      ),
    ),
);

export default enabledAssetsSelector;
